import { useEffect, useState } from 'react';

const useAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem('login_data'));
    setIsAdmin(!!loginData?.isAdmin);
  }, []);

  return [isAdmin];
};

export default useAdmin;
